import firebase from "firebase/app";
import React, { createContext, useContext, useEffect, useState } from "react";
import Cargando from "../components/Cargando";
import app from "./firebaseConfig";

export const contextApp = createContext({
  app: null,
  setFirebaseApp: () => {},
});

export const useData = () => {
  const context = useContext(contextApp);
  if (context === undefined) {
    throw new Error("useData must be used within a Provider");
  }
  return context;
};

export const firebaseInit = async () => {
  return await new Promise((resolve, reject) => {
    try {
      if (!firebase.apps.length) {
        return resolve(firebase.initializeApp(app));
      } else {
        return resolve(firebase.apps[0]);
      }
    } catch (error) {
      if (!/already exist/.test(error.message)) {
        console.error("Firebase initialization error", error.stack);
      }
      return reject(null);
    }
  });
};

firebaseInit();

export const FirebaseProviderApp = ({ children }) => {
  const [firebaseApp, setFirebaseApp] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [showChild, setShowChild] = useState(false);
  const saveSettings = (values) => {
    setFirebaseApp(values);
  };

  useEffect(() => {
    app.auth().onAuthStateChanged(function (user) {
      setUsuario(user);
      setShowChild(true);
    });
  }, [usuario]);
  if (!showChild) {
    return <Cargando />;
  } else {
    return (
      <contextApp.Provider value={{ usuario, firebaseApp, saveSettings }}>
        {children}
      </contextApp.Provider>
    );
  }
};

const FirebaseApp = firebase;

export default FirebaseApp;
